import { HySelectLogo } from "@imi/ui/components/HySelectLogo/HySelectLogo.js";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router";
import styles from "./AuthLayout.module.css";

export default function AuthLayout() {
  const { t } = useTranslation("layout");
  return (
    <section className={styles.AuthLayout}>
      <aside className={styles.AuthBrand}>
        <HySelectLogo />
        {t("title")}
      </aside>

      <div className={styles.AuthAction}>
        <div>
          <aside>
            <Outlet />
          </aside>
        </div>
      </div>
    </section>
  );
}
